import React from 'react';
import PropTypes from 'prop-types';
import imageLogo from '../../assets/images/logo.png';

const Logo = ({ text }) => (
  <div className="logo">
    <img src={imageLogo} width="101" height="30" className="logo__venn" alt="Venn City" />
    <span className="logo__text">{text}</span>
  </div>
);

export default Logo;

Logo.defaultProps = {
  text: ''
};

Logo.propTypes = {
  text: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/Logo/Logo.js